var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3h-1.5v14.25H17v-1.5H3.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.369 10.94 3.302-6.604-1.342-.671-2.698 5.396-3.894-1.46L5.4 12.05l1.2.9L9.263 9.4z"
  })));
};
export { SvgReport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTMuNzUgM2gtMS41djE0LjI1SDE3di0xLjVIMy43NVYzWiIgLz48cGF0aCBkPSJtMTMuMzY4OSAxMC45Mzk4IDMuMzAxOS02LjYwMzk0LTEuMzQxNi0uNjcwODItMi42OTgxIDUuMzk2MDktMy44OTM5My0xLjQ2MDI0TDUuNCAxMi4wNTA0bDEuMi45IDIuNjYyODMtMy41NTAzOSA0LjEwNjA3IDEuNTM5NzlaIiAvPjwvc3ZnPg==";